import { Tooltip, TooltipContent, TooltipTrigger } from '@/_shared/components/ui/tooltip';

/**
 * A control that the person cannot use stays visible, disabled, with the reason in a tooltip. A disabled control
 * gets no pointer events, so a focusable wrapper carries the tooltip. With no `reason`, the control renders as is.
 */
export function GatedControl({
  reason,
  children,
}: {
  reason: string | null;
  children: React.ReactElement;
}): React.ReactElement {
  if (reason === null) return children;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span tabIndex={0} className="inline-flex rounded-md outline-none focus-visible:shadow-primary">
          {children}
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs">{reason}</TooltipContent>
    </Tooltip>
  );
}
